<!-- <div [@routeAnimations]="prepareRoute(outlet)"> -->
<!--<app-header-old></app-header-old>--> 
<app-megaheader></app-megaheader>
<router-outlet #outlet="outlet"></router-outlet>
<app-footer></app-footer>
<!-- </div> -->